import { bool, shape, string } from 'prop-types';

const propTypes = {
  notUseClass: bool,
  className: string,
  style: shape({}),
  fill: string,
};

export default propTypes;
